<template>
    <div class="flex-form__fieldset">
        <label class="flex-form__field" :class="getInvalidClass('url')">
            <div class="flex-form__label">
                URL
            </div>

            <input
                class="flex-form__input"
                type="text"
                :value="dataNew.url"
                @change="onUrlInput"
            >
        </label>

        <label class="flex-form__field">
            <div class="flex-form__label">
                Location
            </div>

            <dropdown
                v-model="dataNew.target"
                class="flex-form__dropdown"
                placeholder="Select One"
                :options="targetOptions"
            />
        </label>
    </div>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'action-url-redirect',
    mixins: [eventDataMixin],

    data() {
        return {
            schema: {
                url: {
                    type: String,
                    default: '',
                    required: true,
                },

                target: {
                    type: String,
                    default: '_blank',
                    required: true,
                },
            },

            targetOptions: [
                { text: 'New Tab', value: '_blank' },
                { text: 'Same Tab', value: '_self' },
            ],
        };
    },

    methods: {
        onUrlInput(e) {
            const { value } = e.target;

            // assume https if the protocol is omitted
            const url = value && !value.startsWith('http') ? `https://${ value }` : value;

            this.dataNew.url = url;
        },
    },
};
</script>
